import axios from "axios";
import { Button, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PPPageHeader from "../pageHeader/PPPageHeader";
import { InvoicePrintDocument } from "./print/ComponentToPrint";
import { PrintMerchantInvoice } from "../../pdf/printMerchantInvoice";

export const InvoicePrint = () => {
  const routes = [
    {
      path: "/invoice-list",
      breadcrumbName: "Нэхэмжлэхүүд",
    },
    {
      path: "first",
      breadcrumbName: "Нэхэмжлэхийн дэлгэрэнгүй",
    },
  ];
  const { id } = useParams();
  const [invoices, setInvoices] = useState();
  const [billing, setBilling] = useState();
  const [loading, setLoading] = useState(false);

  const handleClickprint = () => {
    PrintMerchantInvoice([invoices], [billing]);
  };

  const getInvoiceDesc = useCallback(() => {
    setLoading(true);
    axios
      .get(`/api/v1/invoice/${id}`)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setInvoices(data?.result?.invoice);
          setBilling(data?.result?.billing);
        }
      })
      .catch((e) => {
        console.error("Fetch Invoice For Print: ", e);
      })
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(() => {
    getInvoiceDesc();
  }, [getInvoiceDesc]);
  return (
    <div>
      <PPPageHeader
        title={"Нэхэмжлэхийн дэлгэрэнгүй"}
        breadcrumb={{
          routes,
        }}
      />
      <div className="pdf_container">
        <Button onClick={handleClickprint} disabled={loading || !invoices}>
          Хэвлэх
        </Button>
        <Spin spinning={loading}>
          <div className="pdf_document">
            <InvoicePrintDocument invoice={invoices} billing={billing} />
          </div>
        </Spin>
      </div>
    </div>
  );
};
